import React, { useContext, useEffect, useRef } from "react";
import { Dummy } from "../../../core/Dummy";
import ROUTES from "../../../core/routes";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../App";

interface IEmailVerificationProps {
    element: JSX.Element;
}

/**
 * Redirects a signed-in but unverified user to the verify-email page.
 *
 * ⚠️ BEHAVIOUR CHANGE: this gate never actually fired before. It read
 * `state.firebase.auth.isLoaded` from `react-redux-firebase`, whose provider was
 * never installed, so the flag was permanently `false` and the condition was
 * unreachable. It now reads the real auth state, which means the check works for
 * the first time — on `/home` and `/file/:fileId`, both of which this wraps.
 *
 * Only redirects when a user is actually signed in; an unauthenticated visitor
 * is handled by the page itself (which sends them to sign-in).
 */
function EmailVerification(props: IEmailVerificationProps) {
    const navigate = useRef(useNavigate());
    const { isLoaded, auth } = useContext(AuthContext);

    useEffect(() => {
        if (isLoaded && auth !== null && !auth.emailVerified) {
            navigate.current(`${ROUTES.errorEmailNotVerified}`);
        }
    }, [isLoaded, auth]);

    return <Dummy>{props.element}</Dummy>;
}

export default EmailVerification;
